<template>
  <Modal title="Lista kar" @close-modal="$emit('close-modal', false)">
    <div v-if="penalties.length === 0" class="box">
      <Status type="empty" />
    </div>

    <div v-else class="table-wrapper">
      <table class="table">
        <thead>
          <tr>
            <th class="is-center">Nr</th>
            <th>Kierowca</th>
            <th>Pilot</th>
            <th>Powód</th>
            <th class="is-center">Kara</th>
            <th class="is-center">Odcinek</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="penalty of filteredPenalties" :key="penalty.penaltyId">
            <td class="num is-center">{{ penalty.competitor.number }}</td>
            <td class="driver">
              <div>
                <country-flag :country="getFlag(penalty.competitor.driver.nationality)" size="small" class="flag" />
                {{ penalty.competitor.driver.name }} {{ penalty.competitor.driver.surname }}
              </div>
            </td>
            <td class="driver">
              <div v-if="penalty.competitor.pilot">
                <country-flag :country="getFlag(penalty.competitor.pilot.nationality)" size="small" class="flag" />
                {{ penalty.competitor.pilot.name }} {{ penalty.competitor.pilot.surname }}
              </div>
            </td>
            <td>
              {{ penalty.reason }}
              <!--              <ul>-->
              <!--                <li v-for="penalty in competitor.penalties" :key="penalty">{{ penalty }}</li>-->
              <!--              </ul>-->
            </td>
            <td class="is-center">{{ penalty.seconds | formatPenalty }}</td>
            <td class="is-center">
              <span v-if="penalty.isOnStage">{{ penalty.stageNo }}</span>
              <span v-else>{{ penalty.stageNo + "-" + (penalty.stageNo + 1) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </Modal>
</template>

<script>
import CountryFlag from "vue-country-flag"
import Modal from "@/components/Modal"
import Status from "@/components/Status"

export default {
  name: "PenaltiesModal",

  components: {
    CountryFlag,
    Modal,
    Status,
  },

  props: {
    penalties: Array,
    currentChampionship: Object,
  },
  methods: {
    getFlag: function (value) {
      if (value === "KOS") return "xk"
      return value
    },
  },

  computed: {
    filteredPenalties() {
      return this.penalties.filter(
        (penalty) => penalty.competitor.championshipParticipation[this.currentChampionship.id]
      )
    },
    // competitorPenalties() {
    //   const competitorPenalties = []
    //   const drivers = new Set()
    //
    //   this.penalties.forEach((penalty) => drivers.add(penalty.competitor))
    //
    //   drivers.forEach((driver) => {
    //     const seconds = this.penalties.reduce((acc, penalty) => {
    //       if (penalty.competitor.number === driver.number) {
    //         return acc + penalty.seconds
    //       }
    //     }, 0)
    //
    //     const penalties = this.penalties.reduce((acc, penalty) => {
    //       if (penalty.competitor.number === driver.number) {
    //         return [...acc, penalty.reason]
    //       }
    //     }, [])
    //
    //     const stages = this.penalties.reduce((acc, penalty) => {
    //       if (penalty.competitor.number === driver.number) {
    //         return penalty.isOnStage ? [...acc, penalty.stageNo] : acc
    //       }
    //     }, [])
    //
    //     competitorPenalties.push({
    //       ...driver,
    //       seconds,
    //       penalties,
    //       stages,
    //     })
    //   })
    //
    //   return competitorPenalties
    // },
  },

  filters: {
    formatPenalty: function (penalty) {
      const hrs = Math.floor(penalty / 3600)
      const min = Math.floor(penalty / 60) - hrs*60;
      const sec = penalty - min * 60 - hrs * 3600;
      if(hrs > 0)
        return `${hrs}:${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`
      return `${min}:${String(sec).padStart(2, "0")}`
    },

    formatStage: function (stages) {
      const set = new Set(stages)
      return [...set].join(", ")
    },
  },
}
</script>

<style lang="scss" scoped>
.num {
  font-weight: bold;
  font-size: 1.15rem;
}

.driver div {
  display: flex;
  align-items: center;

  .flag {
    flex-shrink: 0;
    box-shadow: 0 0 0.5rem rgba(#000, 0.25);
    margin: -0.5rem -1rem;
  }
}
</style>
